/**
 * EMERGE THEME REPLICA — Theme JavaScript
 * Cart drawer, search overlay, mobile nav, countdown, carousel, popup, feedback bar
 */

(function() {
  'use strict';

  /* =============================================
     UTILITY
     ============================================= */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, event, handler) => el && el.addEventListener(event, handler);
  const ready = fn => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  /* =============================================
     CART DRAWER
     ============================================= */
  const CartDrawer = {
    init() {
      this.el = $('#cart-drawer');
      if (!this.el) return;

      // Open cart when cart icon clicked
      $$('[data-action="open-cart"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.open(); });
      });

      // Close cart
      $$('[data-action="close-cart"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.close(); });
      });

      // Close on overlay click
      on(this.el, 'click', e => {
        if (e.target === this.el || e.target.classList.contains('cart--overlay')) this.close();
      });

      // Quantity buttons
      $$('.cart--qty-btn').forEach(btn => {
        on(btn, 'click', e => {
          const key = btn.dataset.key;
          const input = $(`.cart--qty-input[data-key="${key}"]`);
          let qty = parseInt(input.value);
          if (btn.dataset.action === 'increase') qty++;
          else qty = Math.max(0, qty - 1);
          this.updateItem(key, qty);
        });
      });

      // Remove buttons
      $$('[data-action="remove"]').forEach(btn => {
        on(btn, 'click', e => {
          e.preventDefault();
          this.updateItem(btn.dataset.key, 0);
        });
      });

      // Keyboard: Escape closes
      on(document, 'keydown', e => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
    },

    open() {
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    isOpen() {
      return this.el.classList.contains('is-open');
    },

    async updateItem(key, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        // Reload to reflect changes (simplest approach)
        window.location.reload();
      } catch (err) {
        console.error('Cart update failed:', err);
      }
    }
  };

  /* =============================================
     SEARCH OVERLAY
     ============================================= */
  const SearchOverlay = {
    init() {
      this.el = $('#search-overlay');
      if (!this.el) return;

      $$('[data-action="open-search"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.open(); });
      });

      $$('[data-action="close-search"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.close(); });
      });

      const clearBtn = $('.search--clear');
      if (clearBtn) {
        on(clearBtn, 'click', () => {
          const input = $('.search--textbox');
          if (input) { input.value = ''; input.focus(); }
        });
      }

      on(document, 'keydown', e => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
        // Cmd/Ctrl + K to open
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.open();
        }
      });
    },

    open() {
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const input = $('.search--textbox');
      if (input) setTimeout(() => input.focus(), 100);
    },

    close() {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    isOpen() {
      return this.el.classList.contains('is-open');
    }
  };

  /* =============================================
     MOBILE NAV DRAWER
     ============================================= */
  const MobileNav = {
    init() {
      this.el = $('#mobile-nav');
      if (!this.el) return;

      $$('[data-action="open-mobile-nav"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.open(); });
      });

      $$('[data-action="close-mobile-nav"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.close(); });
      });

      // Submenu toggles
      $$('[data-action="open-submenu"]').forEach(btn => {
        on(btn, 'click', e => {
          e.preventDefault();
          const container = btn.parentElement.querySelector('[data-menu-level]');
          if (container) {
            container.hidden = false;
            container.classList.add('is-open');
          }
        });
      });

      $$('[data-action="close-submenu"]').forEach(btn => {
        on(btn, 'click', e => {
          e.preventDefault();
          const container = btn.closest('[data-menu-level]');
          if (container) {
            container.classList.remove('is-open');
            setTimeout(() => { container.hidden = true; }, 400);
          }
        });
      });

      on(document, 'keydown', e => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
    },

    open() {
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    isOpen() {
      return this.el.classList.contains('is-open');
    }
  };

  /* =============================================
     NEWSLETTER POPUP
     ============================================= */
  const NewsletterPopup = {
    init() {
      this.el = $('#newsletter-popup');
      if (!this.el) return;

      // Check if user already dismissed
      if (sessionStorage.getItem('newsletter-popup-dismissed')) {
        return;
      }

      const delay = parseInt(this.el.dataset.popupDelay) || 5000;

      setTimeout(() => {
        this.open();
      }, delay);

      $$('[data-action="close-popup"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.close(); });
      });

      $$('[data-action="decline-popup"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.close(); });
      });

      $$('[data-action="reopen-popup"]').forEach(btn => {
        on(btn, 'click', e => { e.preventDefault(); this.open(); });
      });

      on(this.el, 'click', e => {
        if (e.target === this.el || e.target.classList.contains('popup--overlay')) this.close();
      });
    },

    open() {
      this.el.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.el.classList.remove('is-visible');
      document.body.style.overflow = '';
      sessionStorage.setItem('newsletter-popup-dismissed', 'true');
    }
  };

  /* =============================================
     COUNTDOWN TIMER
     ============================================= */
  const CountdownTimer = {
    init() {
      $$('[data-countdown-date]').forEach(el => {
        this.start(el);
      });
    },

    start(el) {
      const targetDate = new Date(el.dataset.countdownDate);
      if (isNaN(targetDate.getTime())) return;

      const update = () => {
        const now = new Date();
        const diff = targetDate - now;

        if (diff <= 0) {
          el.innerHTML = '<span class="countdown-timer--expired">Expired</span>';
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const units = el.querySelectorAll('.countdown-timer--unit');
        if (units.length >= 4) {
          units[0].textContent = String(days).padStart(2, '0');
          units[1].textContent = String(hours).padStart(2, '0');
          units[2].textContent = String(minutes).padStart(2, '0');
          units[3].textContent = String(seconds).padStart(2, '0');
        }
      };

      update();
      setInterval(update, 1000);
    }
  };

  /* =============================================
     CAROUSEL (Featured Collection / Blog)
     ============================================= */
  const Carousel = {
    init() {
      $$('.card-carousel--root, .featured-blog--root').forEach(root => {
        const container = root.querySelector('.card-carousel--container, .featured-blog--wrapper');
        const prevBtn = root.querySelector('.card-carousel--prev, .featured-blog--prev');
        const nextBtn = root.querySelector('.card-carousel--next, .featured-blog--next');

        if (!container) return;

        const scrollAmount = container.querySelector('.product-card--root, .article-card--root');
        const itemWidth = scrollAmount ? scrollAmount.offsetWidth + 16 : 300;

        if (prevBtn) {
          on(prevBtn, 'click', () => {
            container.scrollBy({ left: -itemWidth * 2, behavior: 'smooth' });
          });
        }

        if (nextBtn) {
          on(nextBtn, 'click', () => {
            container.scrollBy({ left: itemWidth * 2, behavior: 'smooth' });
          });
        }
      });
    }
  };

  /* =============================================
     FEEDBACK BAR (Add to cart notification)
     ============================================= */
  const FeedbackBar = {
    init() {
      this.el = $('#feedback-bar');
      if (!this.el) return;

      // Listen for add-to-cart forms
      document.addEventListener('submit', e => {
        const form = e.target;
        if (form.action && form.action.includes('/cart/add')) {
          e.preventDefault();
          this.addToCart(form);
        }
      });
    },

    async addToCart(form) {
      try {
        const formData = new FormData(form);
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        this.show();
      } catch (err) {
        console.error('Add to cart failed:', err);
      }
    },

    show(message) {
      const msg = this.el.querySelector('.feedback-bar--message');
      if (msg && message) msg.textContent = message;
      this.el.classList.add('is-visible');
      setTimeout(() => {
        this.el.classList.remove('is-visible');
      }, 3000);
    }
  };

  /* =============================================
     ANNOUNCEMENT BAR — Close
     ============================================= */
  const AnnouncementBar = {
    init() {
      const closeBtn = $('[data-action="close-announcement"]');
      const bar = $('.announcement--root');
      if (closeBtn && bar) {
        on(closeBtn, 'click', () => {
          bar.style.display = 'none';
          sessionStorage.setItem('announcement-closed', 'true');
        });
      }
      if (sessionStorage.getItem('announcement-closed')) {
        if (bar) bar.style.display = 'none';
      }
    }
  };

  /* =============================================
     HEADER — Sticky on scroll
     ============================================= */
  const Header = {
    init() {
      const header = $('.header--root');
      if (!header) return;

      let lastScroll = 0;
      on(window, 'scroll', () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 100) {
          header.setAttribute('data-sticky', 'true');
        } else {
          header.setAttribute('data-sticky', 'false');
        }
        lastScroll = currentScroll;
      }, { passive: true });
    }
  };

  /* =============================================
     DISCLOSURE (Country/Language selector)
     ============================================= */
  const Disclosure = {
    init() {
      $$('.disclosure--toggle').forEach(toggle => {
        on(toggle, 'click', () => {
          const form = toggle.closest('.disclosure--root').querySelector('.disclosure--form');
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !expanded);
          if (form) form.hidden = expanded;
        });
      });

      // Close on outside click
      on(document, 'click', e => {
        if (!e.target.closest('.disclosure--root')) {
          $$('.disclosure--toggle').forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
            const form = toggle.closest('.disclosure--root').querySelector('.disclosure--form');
            if (form) form.hidden = true;
          });
        }
      });
    }
  };

  /* =============================================
     ADD TO CART — Quick add buttons
     ============================================= */
  const QuickAdd = {
    init() {
      $$('[data-action="add-to-cart"]').forEach(btn => {
        on(btn, 'click', e => {
          e.preventDefault();
          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(() => {
            // Open cart drawer
            CartDrawer.open();
            // Show feedback
            const fb = $('#feedback-bar');
            if (fb) {
              const msg = fb.querySelector('.feedback-bar--message');
              if (msg) msg.textContent = 'Item added to cart';
              fb.classList.add('is-visible');
              setTimeout(() => fb.classList.remove('is-visible'), 3000);
            }
          })
          .catch(err => console.error('Quick add failed:', err));
        });
      });
    }
  };

  /* =============================================
     INIT ALL
     ============================================= */
  ready(() => {
    CartDrawer.init();
    SearchOverlay.init();
    MobileNav.init();
    NewsletterPopup.init();
    CountdownTimer.init();
    Carousel.init();
    FeedbackBar.init();
    AnnouncementBar.init();
    Header.init();
    Disclosure.init();
    QuickAdd.init();

    console.log('Emerge Theme Replica — initialized');
  });

})();
